import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link2 } from "lucide-react";
import { api, shortDate } from "../lib/api";
import { PageHeader, Panel, NeonButton } from "../components/common";

const ACTOR_C = { mari: "#FF2BD6", webhook: "#37E5D7", operator: "#CCFF00" };

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [chain, setChain] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get(`/audit?limit=200${q ? `&entity_id=${encodeURIComponent(q)}` : ""}`).then((r) => setRows(r.data)); }, [q]);
  const verify = async () => {
    const { data } = await api.get("/audit/verify");
    setChain(data);
    data.valid ? toast.success(`Audit chain intact · ${data.entries} entries`) : toast.error("Audit chain broken");
  };
  return (
    <div data-testid="audit-page">
      <PageHeader eyebrow="// append-only · hash-chained · hmac-signed" title="Audit Log">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="filter by entity id" className="bg-canvas border border-white/15 px-3 py-2 font-mono text-xs w-56 focus:outline-none focus:border-brand" data-testid="audit-filter" />
        <NeonButton onClick={verify} data-testid="verify-audit-btn"><Link2 className="w-3 h-3" /> Verify chain</NeonButton>
      </PageHeader>
      {chain && (
        <div className={`mb-6 p-3 border font-mono text-[11px] ${chain.valid ? "border-brand/30 text-brand" : "border-[#F87171]/40 text-[#F87171]"}`} data-testid="audit-chain-result">
          {chain.valid ? "CHAIN INTACT" : `CHAIN BROKEN AT ${chain.broken_at.join(", ")}`} · {chain.entries} entries · head {chain.head_hash.slice(0, 24)}…
        </div>
      )}
      <Panel title="Every action · who · when · from where · what changed">
        <div className="overflow-x-auto">
          <table className="w-full text-left min-w-[860px]" data-testid="audit-table">
            <thead><tr className="label-xs">{["#", "Time", "Actor", "IP", "Action", "Entity", "Change", "Hash"].map((h) => <th key={h} className="pb-3 font-normal pr-3">{h}</th>)}</tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.seq} className="border-b border-divider font-mono text-[11px] align-top" data-testid={`audit-row-${r.seq}`}>
                  <td className="py-2.5 pr-3 text-white/40">{r.seq}</td>
                  <td className="pr-3 text-white/55 whitespace-nowrap">{shortDate(r.ts)}</td>
                  <td className="pr-3 uppercase" style={{ color: ACTOR_C[r.actor] || "#fff" }}>{r.actor}</td>
                  <td className="pr-3 text-white/40">{r.ip || "—"}</td>
                  <td className="pr-3 text-white">{r.action}</td>
                  <td className="pr-3 text-white/60">{r.entity_type}:{r.entity_id}</td>
                  <td className="pr-3 text-white/50 max-w-[280px] break-all">{JSON.stringify(r.diff)}</td>
                  <td className="text-white/30">{r.hash.slice(0, 12)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <p className="font-mono text-xs text-white/35 py-4">No audit entries yet.</p>}
        </div>
      </Panel>
    </div>
  );
}
